import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46bd900c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=46bd900c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bd900c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46bd900c')) {
      api.createRecord('46bd900c', component.options)
    } else {
      api.reload('46bd900c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46bd900c&scoped=true", function () {
      api.rerender('46bd900c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/luckyWheel/setting/index.vue"
export default component.exports